import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";
import PropTypes from "prop-types";
import { Row, Col, Card, CardHeader, CardBody, Button } from "reactstrap";
import queryString from "query-string";

import { Document, Page } from "react-pdf/dist/entry.webpack";
import "react-pdf/dist/Page/AnnotationLayer.css";

import Loader from "../../modules/Loader/BasicLoader";
import createHistory from "../../utils/createBrowserHistory";
import "./FileViewer.css";
import dummy from "./dummyPDF.pdf";

/** To display pdf files you have to provide < base64 string > from API call. You need to know fileName in order to send proper API call. This is example of API call:
 *
 * await axios.get("/file-decoder", {
 *     params: { fileName },
 *  })
 *
 * This call returns < base64Data, url, key >
 */
const FileViewer = ({ history }) => {
  const [fileData, setFileData] = useState({
    url: "",
    key: "",
    base64Data: "",
    isLoading: true,
  });
  const [fileNameState, setFileName] = useState(null);
  const [scale, setScale] = useState(1.2);
  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    const { fileName } = queryString.parse(history.location.search);
    if (fileName) {
      setFileName(fileName);
      const response = await axios.get("/file-decoder", {
        params: { fileName },
      });
      if (response.status === 200) {
        setFileData({
          url: response.data.url,
          key: response.data.key,
          base64Data: response.data.base64Data,
          isLoading: false,
        });
      }
    }
  };

  const onIncreaseClick = () => setScale(scale + 0.1);
  const onDecreaseClick = () => setScale(scale - 0.1);

  const closeViewer = async () => {
    window.close();
  };

  let loader = null;
  if (fileData.isLoading) {
    loader = <Loader />;
  }

  return (
    <Fragment>
      <Row>
        <Col>
          <Card>
            <CardHeader>Options</CardHeader>
            <CardBody>
              <Button
                onClick={onIncreaseClick}
                size="sm"
                className="gold-color-button mr-2"
              >
                Zoom <i className="pi pi-search-plus"></i>
              </Button>
              <Button
                onClick={onDecreaseClick}
                size="sm"
                className="gold-color-button"
              >
                Zoom <i className="pi pi-search-minus"></i>
              </Button>
              <Button
                onClick={closeViewer}
                color="danger"
                size="sm"
                className="float-right ml-2"
              >
                Close
              </Button>
              <a
                href={fileNameState ? `${fileData.url}` : dummy}
                className="btn btn-sm btn-gold float-right"
              >
                Download
              </a>
            </CardBody>
          </Card>
          {fileNameState ? (
            <Fragment>
              {loader}
              {!fileData.isLoading && (
                <Row>
                  <Col md="12">
                    <div style={{ textAlign: "center", margin: "0 auto" }}>
                      <Document
                        file={`data:application/pdf;base64,${fileData.base64Data}`}
                      >
                        <Page
                          pageNumber={1}
                          scale={scale}
                          className="fileViewer"
                        />
                      </Document>
                    </div>
                  </Col>
                </Row>
              )}
            </Fragment>
          ) : (
            // This part is for documentation
            <Row>
              <Col md="12">
                <div style={{ textAlign: "center", margin: "0 auto" }}>
                  <Document file={dummy}>
                    <Page pageNumber={1} scale={scale} className="fileViewer" />
                  </Document>
                </div>
              </Col>
            </Row>
          )}
        </Col>
      </Row>
    </Fragment>
  );
};

FileViewer.propTypes = {
  /** history is provided by default, it represents < props.history > */
  history: PropTypes.object.isRequired,
};

FileViewer.defaultProps = {
  history: createHistory,
};

export default FileViewer;
